import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import ButtonLoader from "@/Components/ButtonLoader";
import ModalPopUp from "@/Components/common/ModalPopUp";
import { RejectIcon } from "@/Components/Icons/RejectIcon";
import {
  addNewInvitedBankedCandidates,
  toggleCheckInvitedCandidateTypeModal,
} from "@/reducers/client_candidates/candidatesinvited";
/**
 * Renders the CheckInvitedCandidateTypeModal component.
 *
 * @return {JSX.Element} The rendered JSX element
 */
const CheckInvitedCandidateTypeModal = () => {
  const [isLoading, setIsLoading] = useState(false);

  const { checkInvitedCandidateTypeModal, newInviteCandidateDetail } =
    useSelector((state) => state.clientCandidatesInvited);
  const dispatch = useDispatch();

  // go back so
  useEffect(() => {
    return () => {
      dispatch(toggleCheckInvitedCandidateTypeModal(false));
    };
  }, []);

  const handleSave = () => {
    setIsLoading(true);
    dispatch(
      addNewInvitedBankedCandidates({
        ...newInviteCandidateDetail,
        loading: isLoading,
        setSubmitting: setIsLoading,
      }),
    );
  };

  const handleClose = () => {
    dispatch(toggleCheckInvitedCandidateTypeModal(false));
  };

  return (
    <ModalPopUp
      show={checkInvitedCandidateTypeModal}
      panelClass="max-w-[590px] max-sm:max-w-[400px]"
    >
      <div className="CheckInvitedCandidateTypeModal_wrapper flex flex-col gap-4">
        <div className="flex justify-between">
          <h3 className="text-[20px] font-semibold leading-[normal] text-black">
            Bank Invite Candidate
          </h3>
          <button
            onClick={handleClose}
            className="text-red outline-none ring-0"
          >
            <RejectIcon />
          </button>
        </div>
        <div className="p-0">
          <div className="grid gap-4">
            <div>
              <label className="text-[14px] font-medium leading-[normal] text-txtColor">
                The candidate is already registered with AppLocum and associated
                with another site's bank. Would you like to invite this
                candidate to join your bank as well?
              </label>
            </div>
          </div>
          <div className="mt-5 flex justify-end gap-4">
            <button
              className="transition-linear relative h-[45px] w-[90px] rounded-lg border border-primary bg-primary text-[14px] font-medium text-white hover:bg-none hover:text-primary"
              onClick={handleSave}
            >
              {isLoading ? <ButtonLoader /> : "Yes"}
            </button>
            <button
              className="transition-linear relative h-[45px] w-[80px] rounded-lg border border-primary bg-white text-[14px] font-medium text-blue hover:bg-blue hover:text-white"
              onClick={handleClose}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </ModalPopUp>
  );
};

export default CheckInvitedCandidateTypeModal;
